/**
 * @fileoverview Hook to determine if user is admin for message rendering purposes
 * 
 * @purpose Provides admin status check for rendering agent messages
 * 
 * @usage Used by KorvoChat to determine if query/helper messages should be rendered
 * 
 * @ownership Core hooks infrastructure
 * 
 * @dependencies 
 * - useAuth hook
 * 
 * @restrictions 
 * - Returns false if auth is not loaded yet
 */

import { useAuth } from './useAuth';

/**
 * Hook to check if current user is admin for message rendering
 * 
 * @returns true if user is admin, false otherwise
 */
export function useIsAdminForMessages(): boolean {
  const { isAdmin } = useAuth();
  return isAdmin ?? false;
}

